import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    ticketStockBox: {
      padding: '0px 112px 0px 112px',
      flex: '1 1 0%',
      background: 'transparent',
      [theme.breakpoints.only('lg')]: {
        padding: '0px 60px 0px 60px'
      }
    },
    ticketStockButtons: {
      [theme.breakpoints.only('lg')]: {
        width: '350px'
      }
    }
  })
);
